import * as React from 'react';

const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.26003 5.83002L8.74029 7.17494L5.2659 11H21.9999V13H5.2579L8.74112 16.8297L7.26147 18.1753L1.6499 12.0047L7.26003 5.83002Z", fill: "currentColor" }));

export { SvgArrowLeft as default };
